export const deviceDisableReason = {
  DISABLED_BY_PROFILE: "DISABLED_BY_PROFILE",
  NO_PERMISSION: "NO_PERMISSION",
  NO_DEVICE: "NO_DEVICE",
  SUSPENDED: "SUSPENDED",
  SOFT_MUTED: "VIDYO_ROOMMODERATIONTYPE_SoftMute",
  HARD_MUTED: "VIDYO_ROOMMODERATIONTYPE_HardMute",
};

export const deviceTooltipTimeout = 3000;

export const privacyPolicyLink = "https://www.vidyo.com/privacy-policy";
export const termsAndConditionsLink =
  "https://www.vidyo.com/cloudservices-user-terms-and-conditions";
export const patentNotices = "https://www.vidyo.com/company/patent-notices";
export const vidyoOSSAttributions =
  "http://www.vidyo.com/wp-content/uploads/Vidyo-OSS-Attributions.pdf";
export const eulaAgreement = "http://www.vidyo.com/eula";

export const tcData = {
  LINK_URL: "https://links.vidyocloud.com",
  LINK_JSON_NAME: "links.json",
  TENANT_JSON_NAME: "tenantsdirectory.json",
  TERMS_JSON_NAME: "terms",
  PRIVACY_JSON_NAME: "privacy",
  LOCAL_VERSION: "tcConsentVersion",
  SERVER_TIMEOUT: 10 * 1000,
};

export const tabletsGridParticipantLimit = 3;
export const participantLimit = 8;
